<template>
  <div class="popup popup-gene-only" style="overflow-x: hidden; padding: 3%">
    <div class="">
      <div>
        <div class="search-input" style="width: 85%; float: left; border-radius: 40px;">
          <label class="icon icon-search" for="searchGene"></label>
          <input  type="search" id="searchGene" placeholder='请输入查询基因ID、基因名称、转录本' v-model.trim="queryName"/>
        </div>
        <div style="width: 15%; float: right; text-align: center; font-size: 14px; color: #979797; padding-top: 5px;">
          <span class="close-popup">取消</span>
        </div>
      </div>
    </div>
    <div class="searchTr" style="margin-top: 5vh">
      <div style="border-bottom: solid 1px #EFEEF3; padding: 10px">
        <span style="font-weight: bold">选择物种</span>
        <span v-show="this.radioChecked === ''" style="color:red;font-size: 12px">
          <i class="icon-font emkt-icon-gantanhao" style="font-size: 12px"></i>
          查询基因前请先选择物种</span>
        <span style="float: right">
            <i class="icon-font emkt-icon-zhankai" v-show="!showMore" @click="showMore = !showMore" style="font-size: 13px; color: #5878FA"></i>
            <i class="icon-font emkt-icon-shouqi" v-show="showMore" @click="showMore = !showMore" style="font-size: 13px; color: #5878FA"></i>
        </span>
      </div>
      <div style="text-align: center; padding: 10px" id="taxName">
        <div class="searchRadioBox" style="width: 33%" v-show="showMore || (radioChecked === '9606'
        || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')">
          <label class="searchBox default" :class="{selected: radioChecked === '9606'}" for="human">人类 {{human}}</label>
          <input class="searchRadio input" type="radio" id="human" value="9606" @click="clickRadio"/>
        </div>
        <div class="searchRadioBox" style="width: 32%" v-show="showMore || (radioChecked === '9606'
        || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')">
          <label class="searchBox default" :class="{selected: radioChecked === '10116'}" for="rat">大鼠 {{rat}}</label>
          <input class="searchRadio input" type="radio" id="rat" value="10116" @click="clickRadio"/>
        </div>
        <div class="searchRadioBox" style="width: 32%" v-show="showMore || (radioChecked === '9606'
        || radioChecked === '10116' || radioChecked === '10090' ||radioChecked === '')">
          <label class="searchBox default" :class="{selected: radioChecked === '10090'}" for="mouse">小鼠 {{mouse}}</label>
          <input class="searchRadio input" type="radio" id="mouse" value="10090" @click="clickRadio"/>
        </div>

        <div>
          <div class="searchRadioBox" style="width: 20%"  v-show="showMore || radioChecked === '10123'">
            <label class="searchBox default" :class="{selected: radioChecked === '10123'}" for="pig">猪 {{pig}}</label>
            <input class="searchRadio input" type="radio" id="pig" value="10123" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 25%" v-show="showMore || radioChecked === '10125'">
            <label class="searchBox default" :class="{selected: radioChecked === '10125'}" for="rabbit">兔子 {{rabbit}}</label>
            <input class="searchRadio input" type="radio" id="rabbit" value="10125" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 25%" v-show="showMore || radioChecked === '10124'">
            <label class="searchBox default" :class="{selected: radioChecked === '10124'}" for="sheep">绵羊 {{sheep}}</label>
            <input class="searchRadio input" type="radio" id="sheep" value="10124" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 25%" v-show="showMore || radioChecked === '10120'">
            <label class="searchBox default" :class="{selected: radioChecked === '10120'}" for="rice">水稻 {{rice}}</label>
            <input class="searchRadio input" type="radio" id="rice" value="10120" @click="clickRadio"/>
          </div>

          <div class="searchRadioBox" style="width: 32%" v-show="showMore || radioChecked === '10121'">
            <label class="searchBox default" :class="{selected: radioChecked === '10121'}" for="zebrafish">斑马鱼 {{zebrafish}}</label>
            <input class="searchRadio input" type="radio" id="zebrafish" value="10121" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 32%" v-show="showMore || radioChecked === '10118'">
            <label class="searchBox default" :class="{selected: radioChecked === '10118'}" for="Gallus_gallus">鸡 {{Gallus_gallus}}</label>
            <input class="searchRadio input" type="radio" id="Gallus_gallus" value="10118" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 33%" v-show="showMore || radioChecked === '10119'">
            <label class="searchBox default" :class="{selected: radioChecked === '10119'}" for="thale_cress">拟南芥 {{thale_cress}}</label>
            <input class="searchRadio input" type="radio" id="thale_cress" value="10119" @click="clickRadio"/>
          </div>

          <div class="searchRadioBox"  style="width: 34%" v-show="showMore || radioChecked === '10128'">
            <label class="searchBox default" :class="{selected: radioChecked === '10128'}" for="yeast">酵母 {{yeast}}</label>
            <input class="searchRadio input" type="radio" id="yeast" value="10128" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 64%" v-show="showMore || radioChecked === '10127'">
            <label class="searchBox default" :class="{selected: radioChecked === '10127'}" for="African_clawed_frog">非洲爪娃 {{African_clawed_frog}}</label>
            <input class="searchRadio input" type="radio" id="African_clawed_frog" value="10127" @click="clickRadio"/>
          </div>

          <div class="searchRadioBox" style="width: 30%" v-show="showMore || radioChecked === '10122'">
            <label class="searchBox default" :class="{selected: radioChecked === '10122'}" for="fruit_fly">果蝇 {{fruit_fly}}</label>
            <input class="searchRadio input" type="radio" id="fruit_fly" value="10122" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 52%" v-show="showMore || radioChecked === '10126'">
            <label class="searchBox default" :class="{selected: radioChecked === '10126'}" for="domestic_silkworm">家蚕 {{domestic_silkworm}}</label>
            <input class="searchRadio input" type="radio" id="domestic_silkworm" value="10126" @click="clickRadio"/>
          </div>
          <div class="searchRadioBox" style="width: 15%" v-show="showMore || radioChecked === '10117'">
            <label class="searchBox default" :class="{selected: radioChecked === '10117'}" for="others">{{others}}</label>
            <input class="searchRadio input" type="radio" id="others" value="10117" @click="clickRadio"/>
          </div>
          <span v-show="!showMore &&(radioChecked !== '9606'
        && radioChecked !== '10116' && radioChecked !== '10090' && radioChecked !== '')" @click="showMore = !showMore" style="font-size: 13px; color: #5878FA; margin-left: 20px">
          选择其它物种
          <i class="icon-font emkt-icon-zhankai" style="font-size: 12px"></i>
        </span>
        </div>

        <div style="margin-top: 5px">
          <div v-show="!showMore && (radioChecked === '9606'
        || radioChecked === '10116' || radioChecked === '10090' || radioChecked === '')" @click="showMore = !showMore" style="font-size: 13px; color: #5878FA">
            更多物种
            <i class="icon-font emkt-icon-zhankai" style="font-size: 12px"></i>
          </div>
          <div v-show="showMore" @click="showMore = !showMore" style="font-size: 13px; color: #5878FA">
            点击收起
            <i class="icon-font emkt-icon-shouqi" style="font-size: 12px"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!showMatchData">
      <h6>注意事项：</h6>
      <div style="font-size: .6rem;margin-left: 1rem;margin-right: 1rem">1.数据来源为NCBI refseq数据库，mirBase数据库。</div>
      <div style="font-size: .6rem;margin-left: 1rem;margin-right: 1.1rem">2.NCBI中refseq数据库
        <span style="color: #5878FA">NM、XM</span>开头的accession为
        <span style="color: #5878FA">编码基因</span>；
        <span style="color: #5878FA">NR、XR</span>开头的accession为
        <span style="color: #5878FA">非编码基因</span>。</div>
      <div style="font-size: .6rem;margin-left: 1rem;margin-right: 1rem">3.<span style="color: #5878FA">pre-miRNA为MicroUp</span>基因类型，
        <span style="color: #5878FA">mature miRNA为MicroDown</span>基因类型；</div>
      <div style="font-size: .6rem;margin-left: 1rem;margin-right: 1rem">5.如果您在基因选择上遇到任何疑问，请返回上一步点击左下角
        <span style="color: #5878FA">“在线客服”</span>寻求帮助；</div>
    </div>
    <div v-if="showMatchData">
      <div v-for="(searchData, index) in queryRes">
        <div class="searchTr">
          <div @click="searchTarget(searchData, index)" :class=" close ? 'close-popup': ''" style="padding: 10px">
            <div>
              <div style="width: 100%;">
                <div style="float: left;width: 60%;">
                  <span style="font-size: 16px; font-weight: bold; margin-right: 5px;">{{searchData.title}}</span>
                  <span style="font-size: 10px;color: #979797;">codeSize:{{searchData.genes[0].cdsSize}}</span>
                  <div style="color: #979797; font-size: 10px;  overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                    <span>{{searchData.genes[0].matched}}</span>
                    <span v-if="searchData.genes[0].ttttflag === 0">连续4T：否</span>
                    <span v-if="searchData.genes[0].ttttflag === 1">连续4T：是</span>
                  </div>
                </div>
                <div style="float: right;width: 40%;">
                  <div style="width: 41px; height: 70px; float: right; margin: -10px -10px 0 0;"
                       @click.stop="searchData.open = !searchData.open">
                    <i class="icon-font emkt-icon-zhankai"
                       style=" position: relative; float:right; top: 22px;right:12px;color: #5878FA; font-size: 16px;z-index: 999;"
                       v-if="(searchData.genes.length > 1) && !searchData.open"></i>
                    <i class="icon-font emkt-icon-shouqi"
                       style=" position: relative; float:right; top: 22px;right:12px;color: #5878FA; font-size: 16px;z-index: 999;"
                       v-else-if="searchData.open"></i>
                  </div>
                  <div style="float: right;text-align: end;margin-top: 15px;font-size: 12px;width: 75%">
                    <div class="sub-title">{{ searchData.genes[0].subtitle }}</div>
                    <div v-if="searchData.genes[0].recommended" style="color: red;">推荐转录本</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
          <div v-if="searchData.text !== '' && searchData.open">
            <div v-for="(gens, indexs) in searchData.genes" @click ="searchTarget(gens, indexs)" :class=" close ? 'close-popup': ''">
              <div v-if="indexs !== 0" style="border-top: #EFEEF3 0.5px solid;padding: 10px;">
                <div>
                  <div style="width: 100%;">
                    <span style="font-size: 16px; font-weight: bold; margin-right: 5px;float: left">{{searchData.title}}</span>
                    <span style="font-size: 10px;color: #979797;">codeSize:{{gens.cdsSize}}</span>
                  </div>
                  <div style="color: #979797; font-size: 10px; width: 60%; overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                    <span>{{gens.matched}}</span>
                    <span v-if="searchData.ttttflag === 0">连续4T：否</span>
                    <span v-if="searchData.ttttflag === 1">连续4T：是</span>
                  </div>
                </div>
                <div style="float: right;position: relative;top: -35px;font-size: 12px;text-align: end;width: 40%;">
                  <div class="sub-title">{{ gens.subtitle }}</div>
                  <div v-if="gens.recommended" style="color: red;">推荐转录本</div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import emkt from '../../emkt'
  import {mapState, mapMutations} from 'vuex'
  export default {
    mounted () {
//      this.fetchdata()
    },
    created () {
//      this.fetchdata()
    },
    data () {
      return {
        showMore: false,
        rat: emkt.Rat,
        mouse: emkt.Mouse,
        human: emkt.Human,
        others: emkt.others,
        Gallus_gallus: emkt.Gallusgallus,
        thale_cress: emkt.thalecress,
        rice: emkt.rice,
        zebrafish: emkt.zebrafish,
        fruit_fly: emkt.fruitfly,
        pig: emkt.pig,
        sheep: emkt.sheep,
        rabbit: emkt.rabbit,
        domestic_silkworm: emkt.domesticsilkworm,
        African_clawed_frog: emkt.Africanclawedfrog,
        yeast: emkt.yeast,
        radioChecked: '', // default
        queryRes: [],
        matchNMIDFirst: '',
//        isClickMore: false,
        showMatchData: false,
        geneData: '',
        matchData: [],
        queryName: '',
        popupTrue: true,
        mateData: emkt.getEmktMetaData().dictionariesMap[61031],
        close: true
      }
    },
    watch: {
      'queryName': 'getQueryResult',
      'finderSearchText': function (val) {
        this.queryName = val
      }
    },
    methods: {
      ...mapMutations([
        'GENE_SEARCH_RESULT', 'FINDER_SEARCH_TEXT', 'HARD_GENE_INFO'
      ]),
      clickRadio (tar) {
        if (tar.target.defaultValue !== '9606' && tar.target.defaultValue !== '10116' && tar.target.defaultValue !== '10090') {
          $('#allothers').css('background-color', '#0261b5')
        } else {
          $('#allothers').css('background-color', '#DDDDDD')
        }
        this.radioChecked = tar.target.defaultValue
        if (this.queryName !== '') {
          console.log(this)
          emkt.throttle(this.getQueryResult, 250, this)
        }
      },
      fetchdata () {
        console.log(this.geneSearchResult['/finder/finderMerchandises'].data)
      },
      openwuzhong () {
        $.openPanel('#panel-left-demo')
      },
      getQueryResult () {
        // if (this.queryName === '' || this.queryName === undefined || this.radioChecked === '') {
        //   this.showMatchData = false
        //   return
        // }
        // let _this = this
        // let param = {
        //   'taxId': this.radioChecked,
        //   'entered': this.queryName
        // }
        // this.gcapi('queryGene', param).then((res) => {
        //   res.body.result.forEach(item => {
        //     item.open = false
        //   })
        //   this.queryRes = res.body.result
        //   this.showMatchData = true
        // })
      },
      searchTarget (selectedItem, index) {
        console.log(selectedItem, index)
        let geneGuid
        if (selectedItem.genes) {
          geneGuid = selectedItem.genes[0].geneGuid
        } else {
          geneGuid = selectedItem.geneGuid
        }
        this.close = true
        let _this = this
        this.gcapi('getGeneByGUID', geneGuid).then((res) => {
          _this.geneData = res.body.result
          let router = _this.$router.history.current.path
          let gData = _this.geneData
          let geneInfo = {}
          let gene
          gene = {'data': gData}
          geneInfo[router] = gene
          var param = {
            geneID: gData.geneID, nM_ID: gData.NMID
          }
          console.log(param)
          _this.gcapi('getHardGeneDescriptions', param).then((res) => {
            _this.FINDER_SEARCH_TEXT('')
            _this.FINDER_SEARCH_TEXT(gData.symbol)
            _this.GENE_SEARCH_RESULT(geneInfo)
            if (res.body.result) {
              _this.HARD_GENE_INFO(res.body.result)
            } else {
              _this.HARD_GENE_INFO([])
            }
          })
        })
//        this.searchValue = selectedItem
//        this.getHistoryData()
//        if (this.$route.query) {
//          selectedItem.promotionGuid = this.$route.query.id
//        }
//        this.$router.push({
//          name: 'searchresults',
//          query: {search: JSON.stringify(selectedItem)}
//        })
      }
    },
    computed: {
      ...mapState([
        'geneSearchResult', 'finderSearchText'
      ])
    }
  }
</script>

<style scoped>
  input[type="radio"] {
    display: none;
  }

  .sub-title {
    color: #5878FA;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .search_history {
    background-color: #fff;
    margin-bottom: 0.4rem;
  }
  .list-block {
    margin-top: 1rem;
  }
  .search-input input {
    border-radius: 1.25rem;
  }
  .searchTr {
    border-radius: 10px;
    background: white;
    border: #EFEEF3 solid 1px;
    width: 100%;
    margin-bottom: 5%;
  }
  .searchTr .searchBox.default {
    width: 100%;
    display: inline-block;
    text-decoration: none;
    color: #000000;
    font-size: .5rem;
    line-height: 1;
    background-color: #EFEEF3;
    border: #EFEEF3 1px solid;
    padding: 0.5em;
    border-radius:40px;
    text-align: center;
  }
  .searchTr .searchBox.selected {
    display: inline-block;
    text-decoration: none;
    color: #5878FA;
    font-size: .5rem;
    line-height: 1;
    background: rgba(88, 120, 250, 0.15);
    border: #5878FA 1px solid;
    padding: 0.5em;
    border-radius:40px;
    text-align: center;
  }
  .searchRadioBox {
    display: inline-block;
  }

  .searchSecondTr .searchSecondBox .default {
    width: 100%;
    text-decoration: none;
    color: #000000;
    background-color: #EFEEF3;
    padding: 0.5em;
    border-radius:30px;
    text-align: center;
    /*margin-left: 10%;*/
  }
  .searchSecondTr .searchSecondBox .selected {
    display: inline-block;
    width: 100%;
    text-decoration: none;
    color: #000000;
    background-color: #045aa5;
    padding: 0.5em;
    border-radius:30px;
    text-align: center;
    /*margin-left: 10%;*/
  }
  .borderBottom {
    border-bottom: 1px solid #dddddd;
  }
  .blueTitle {
    width: 4rem;
    border-bottom: 2px solid #0074D9;
  }
  .badge {
    color:#0894ec;
    background: white;
    text-decoration: none;
    font-size: 0.6rem;
  }
  .list-block .item-title {
    font-weight: bold;
  }
  .showSec-enter-active {
    animation: showSec-in .5s;
  }
  .showSec-leave-active {
    animation: showSec-in .5s reverse;
  }
  @keyframes showSec-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// SearchGeneBox.vue?5c87577e